import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from 'ttag';

import { FeedFilterTitle } from '@components/FeedFilterTitle';

export default class ColorFilter extends Component {
  state = {
    isActive: true,
  };

  handleToggle = () => {
    this.setState({ isActive: !this.state.isActive });
  };

  handleColorChanged(id) {
    this.props.eventStream.next({
      action: 'setColorFilter',
      id,
    });
  }

  render() {
    const cls = classNames({
      'b-filter__section': true,
      'b-filter__section_state_active': this.state.isActive,
    });

    return (
      (<div className={cls} onClick={this.handleToggle}>
        <FeedFilterTitle
          title={t`Колір`}
          hide={!this.state.isActive}
          onClick={this.handleToggle}
        />
        <ul className="b-filter__content b-color-list">
          {
            this.props.filters.map((d) => {
              const isChecked =
                this.props.checked && this.props.checked.includes(d.id);
              const clsLabel = classNames({
                'b-color-list__label': true,
                'b-color-list__label_type_bordered': d.is_white,
                'b-color-list__label_type_multicolored': d.is_multicolor,
              });

              return (
                <li className="b-color-list__item" key={`color-${d.id}`}>
                  <input
                    id={`color-${d.id}`}
                    className="b-color-list__input"
                    name={`color-${d.id}`}
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => this.handleColorChanged(d.id)}
                  />
                  <label
                    className={clsLabel}
                    htmlFor={`color-${d.id}`}
                    style={{ backgroundColor: d.hex }}
                  >
                    {d.name}
                  </label>
                </li>
              );
            })
          }
        </ul>
      </div>)
    );
  }
}

ColorFilter.propTypes = {
  filters: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
};
